export default __webpack_public_path__ + "static/media/footerpolygonnew.040e02e4.svg";